import { Info } from "lucide-react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const StatBlock = ({
  label,
  value,
  unit,
  accent,
  testId,
  tooltip,
  tooltipTestId,
  className,
}) => (
  <div
    className={cn("metric-card", className)}
    data-testid={testId}
    style={accent ? { borderLeft: `3px solid ${accent}` } : undefined}
  >
    {tooltip ? (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center gap-1.5 card-label focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--surface-primary)]"
            aria-label={`${label}: ${tooltip}`}
            data-testid={tooltipTestId || `${testId}-tooltip-trigger`}
          >
            <span>{label}</span>
            <Info className="w-3 h-3 shrink-0 opacity-70" strokeWidth={1.5} aria-hidden="true" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-xs bg-[var(--surface-elevated)] text-[var(--text-primary)] border border-[var(--border-primary)] text-xs leading-relaxed"
          side="top"
        >
          {tooltip}
        </TooltipContent>
      </Tooltip>
    ) : (
      <div className="card-label">{label}</div>
    )}
    <div
      className="metric-value mt-3"
      style={accent ? { color: accent } : undefined}
    >
      {value ?? "—"}
      {unit && value != null && value !== "—" ? (
        <span className="metric-unit">{unit}</span>
      ) : null}
    </div>
  </div>
);
